import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/yacht-equipment-pack-categories', data)
    .then(response => {
      return response.data
    })
}
function update(data, id) {
  return axios.patch(`/yacht-equipment-pack-categories/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  fetch(params) {
    return axios.get('/yacht-equipment-pack-categories', { params: params })
      .then(response => {
        return response.data
      })
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  destroy(id) {
    return axios.delete(`/yacht-equipment-pack-categories/${id}`)
  }
}
